export default "__VITE_ASSET__1kSyImbh__"